<div id="wrap" class="wrap">
  <header class="header">
    <app-header></app-header>
  </header>
  <nav class="lnb">
    <app-left-menu></app-left-menu>
  </nav>
  <div class="contents">
    <router-outlet></router-outlet>
  </div>
  <!--
    <footer class="footer">
      <app-footer></app-footer>
    </footer>
    -->
</div>
